var _circle, _rect, _path, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavebg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 701,
    height: 776,
    viewBox: "0 0 701 776",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 380.5,
    cy: 195.5,
    r: 195.5,
    fill: "url(#paint0_radial)",
    fillOpacity: 0.39
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 402.727,
    y: 653.963,
    width: 48.498,
    height: 351.244,
    transform: "rotate(-20.0567 402.727 653.963)",
    fill: "#FCCC63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M487.256 851.466C487.256 851.466 392.826 744.716 463.857 733.577C534.887 722.438 531.885 833.627 531.885 833.627L487.256 851.466Z",
    fill: "#A0616A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 319.404,
    y: 633.92,
    width: 48.498,
    height: 351.244,
    transform: "rotate(22.2946 319.404 633.92)",
    fill: "#FCCC63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224.747 790.766C224.747 790.766 296.278 696.687 321.86 730.877C347.441 765.067 277.189 839.963 277.189 839.963L224.747 790.766Z",
    fill: "#FFB8B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.45 447.993L333.72 408.28L355.558 380.572L369.994 362.411L393.074 337.149L390.347 359.285L389.768 376.5L390.415 391.863L392.294 402.924L395.086 411.235L399.122 422.591L405.616 434.876L414.269 448.389L423.24 461.885L432.824 472.63L443.973 488.288L454.783 502.396L466.545 523.885L479.46 505.428L479.177 521.092L479.825 536.772L483.263 557.979L481.773 580.429L478.734 597.65L470.767 624.096L460.943 641.948L445.549 658.578L432.634 668.754L410.759 678.949L394.42 682.965L376.236 683.321L364.199 682.113L348.158 676.614L333.651 669.262L320.99 657.607L308.624 643.185L298.416 629.375L287.267 605.418L281.054 583.917L277.013 561.496L277.27 541.515L278.459 519.065L280.257 499.997L280.197 471.418L277.392 457.276L272.432 443.155L264.379 429.323L275.485 432.683L293.403 440.028L309.45 447.993Z",
    fill: "#EE1E14",
    stroke: "#EE1E14",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.482 456.25L315.991 468.103L327.274 480.546L336.367 491.801L345.643 505.866L349.483 513.701L352.48 509.462L354.274 500.211L355.694 481.784L354.587 454.328L356.79 427.453L367.141 403.014L377.97 385.688L385.591 373.597L381.597 385.271L383.28 416.46L386.564 430.609L391.781 441.783L427.122 503.668L432.966 517.349L435.431 530.824L436.262 545.103L437.279 554.953L438.704 564.606L440.728 571.235L446.977 574.654L454.837 574.638L461.056 572.206L464.514 567.646L467.715 559.192L469.698 546.722L471.731 557.974L474.183 573.672L472.619 599.426L467.851 623.568L458.24 645.32L446.991 657.419L430.53 668.71L414.863 677.208L401.179 681.647L389.123 682.882L379.059 683.312L367.799 682.127L356.516 678.131L345.636 671.307L335.165 664.092L325.626 652.57L313.311 631.255L306.89 613.859L304.193 599.691L302.4 584.49L301.103 568.523L301.483 554.242L303.271 541.967L305.856 528.072L309.245 516.186L313.449 502.501L315.044 491.437L314.403 481.177L309.947 467.902L303.482 456.25Z",
    fill: "#F38F19",
    stroke: "#F38F19",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.829 437.407L381.379 467.004L395.385 497.2L404.879 519.241L413.646 542.339L422.15 568.858L427.185 591.964L428.715 609.562L427.997 623.226L425.789 638.2L421.57 648.451L416.39 661.337L409.674 669.749L401.985 675.549L391.785 680.566L380.901 683.311L371.876 682.452L361.672 677.997L351.21 671.197L343.72 658.857L340.201 646.528L338.198 638.116L337.658 624.723L337.876 608.965L340.589 592.396L347.758 573.473L356.443 557.429L366.845 535.347L372.525 518.252L374.482 505.373L373.464 489.099L370.922 465.719L363.829 437.407Z",
    fill: "#F3B326",
    stroke: "#F3B326",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.396 616.738L353.087 598.495L359.73 582.546L365.265 568.918L371.91 554.419L379.393 541.366L388.633 528.437L385.792 541.932L385.82 555.259L387.514 566.844L393.094 574.944L401.744 586.804L410.117 599.824L414.591 610.823L418.218 624.124L419.63 633.971L419.116 647.589L415.799 657.736L408.865 667.89L397.758 677.474L389.422 681.837L383.027 683.299L375.235 681.867L366.043 676.382L358.511 666.548L353.48 654.97L348.718 639.625L346.748 628.62L348.396 616.738Z",
    fill: "#FACC7D",
    stroke: "#FACC7D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M378.619 279.239C425.906 279.239 464.239 240.906 464.239 193.619C464.239 146.333 425.906 108 378.619 108C331.333 108 293 146.333 293 193.619C293 240.906 331.333 279.239 378.619 279.239Z",
    fill: "#FCCC63"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.767,
    cy: 204.457,
    r: 11.9217,
    fill: "#DC9BA3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 426.306,
    cy: 184.951,
    r: 11.9217,
    fill: "#DC9BA3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M362.361 216.38C384.037 222.883 395.959 220.716 408.964 203.375",
    stroke: "#3F3D56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M355.448 174.222C348.957 169.053 344.078 172.069 343.729 179.187",
    stroke: "#3F3D56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M400.959 164.888C395.955 158.268 390.48 159.978 388.374 166.786",
    stroke: "#3F3D56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.64 324.169C135.637 324.169 154.28 305.526 154.28 282.529C154.28 259.532 135.637 240.889 112.64 240.889C89.6429 240.889 71 259.532 71 282.529C71 305.526 89.6429 324.169 112.64 324.169Z",
    fill: "#505066"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.898 331C200.573 331 228.683 304.137 228.683 271C228.683 237.863 200.573 211 165.898 211C131.223 211 103.113 237.863 103.113 271C103.113 304.137 131.223 331 165.898 331Z",
    fill: "#505066"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M206.442 330.084C232.45 330.084 253.534 309.001 253.534 282.992C253.534 256.984 232.45 235.9 206.442 235.9C180.433 235.9 159.35 256.984 159.35 282.992C159.35 309.001 180.433 330.084 206.442 330.084Z",
    fill: "#505066"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M242.508 330.94C262.305 330.94 278.354 314.891 278.354 295.094C278.354 275.297 262.305 259.248 242.508 259.248C222.711 259.248 206.662 275.297 206.662 295.094C206.662 314.891 222.711 330.94 242.508 330.94Z",
    fill: "#505066"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M112.393 285.786C118.685 285.786 123.786 280.685 123.786 274.393C123.786 268.101 118.685 263 112.393 263C106.101 263 101 268.101 101 274.393C101 280.685 106.101 285.786 112.393 285.786Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M112.609 279.968C115.426 279.968 117.71 277.684 117.71 274.867C117.71 272.049 115.426 269.766 112.609 269.766C109.792 269.766 107.508 272.049 107.508 274.867C107.508 277.684 109.792 279.968 112.609 279.968Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M155.393 288.241C161.685 288.241 166.786 283.14 166.786 276.848C166.786 270.556 161.685 265.455 155.393 265.455C149.101 265.455 144 270.556 144 276.848C144 283.14 149.101 288.241 155.393 288.241Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M155.867 281.735C158.685 281.735 160.969 279.451 160.969 276.633C160.969 273.815 158.685 271.531 155.867 271.531C153.05 271.531 150.766 273.815 150.766 276.633C150.766 279.451 153.05 281.735 155.867 281.735Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M157.041 261.859C162.071 263.597 169.165 268.744 169.646 274.666C170.56 285.918 159.78 273.559 156.675 272.023C153.569 270.487 146.069 270.619 144.545 268C142.479 264.591 146.634 259.961 149.841 259.821C151.865 259.775 154.131 261.261 156.055 261.462",
    fill: "#64647A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M123.731 261.157C119.736 257.641 111.757 254.013 106.37 256.519C96.1339 261.28 112.204 264.553 115.073 266.495C117.943 268.437 121.531 275.024 124.56 275.057C128.545 275.17 130.519 269.27 129.058 266.412C128.099 264.63 125.688 263.392 124.563 261.818",
    fill: "#64647A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M654.609 329.797C630.794 329.797 611.489 310.491 611.489 286.677C611.489 262.862 630.794 243.557 654.609 243.557C678.423 243.557 697.729 262.862 697.729 286.677C697.729 310.491 678.423 329.797 654.609 329.797Z",
    fill: "#5D5C6F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M599.455 336.874C563.546 336.874 534.437 313.173 534.437 283.937C534.437 254.701 563.546 231 599.455 231C635.363 231 664.473 254.701 664.473 283.937C664.473 313.173 635.363 336.874 599.455 336.874Z",
    fill: "#5D5C6F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M557.47 335.925C530.536 335.925 508.702 314.09 508.702 287.157C508.702 260.223 530.536 238.389 557.47 238.389C584.404 238.389 606.238 260.223 606.238 287.157C606.238 314.09 584.404 335.925 557.47 335.925Z",
    fill: "#5D5C6F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M520.121 336.81C499.62 336.81 483 320.191 483 299.689C483 279.188 499.62 262.568 520.121 262.568C540.623 262.568 557.242 279.188 557.242 299.689C557.242 320.191 540.623 336.81 520.121 336.81Z",
    fill: "#5D5C6F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M654.5 295C649.253 295 645 290.747 645 285.5C645 280.253 649.253 276 654.5 276C659.747 276 664 280.253 664 285.5C664 290.747 659.747 295 654.5 295Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M656.239 291.059C653.407 291.059 651.111 288.763 651.111 285.931C651.111 283.099 653.407 280.803 656.239 280.803C659.071 280.803 661.367 283.099 661.367 285.931C661.367 288.763 659.071 291.059 656.239 291.059Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M622.5 296C617.253 296 613 291.747 613 286.5C613 281.253 617.253 277 622.5 277C627.747 277 632 281.253 632 286.5C632 291.747 627.747 296 622.5 296Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M623.405 292C620.656 292 618.428 289.761 618.428 287C618.428 284.239 620.656 282 623.405 282C626.153 282 628.381 284.239 628.381 287C628.381 289.761 626.153 292 623.405 292Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M616.959 272.244C611.926 273.337 604.517 277.47 603.376 283.107C601.207 293.816 612.985 283.175 616.146 282.055C619.306 280.935 626.5 281.922 628.265 279.58C630.641 276.54 627.179 271.615 624.112 271.111C622.174 270.836 619.825 272.003 617.952 271.977",
    fill: "#504F66"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M638.139 275.251C642.005 271.848 649.728 268.336 654.942 270.762C664.85 275.37 649.296 278.538 646.519 280.418C643.742 282.297 640.268 288.672 637.337 288.705C633.479 288.813 631.569 283.104 632.983 280.336C633.912 278.612 636.245 277.414 637.334 275.891",
    fill: "#504F66"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(380.5 195.5) rotate(90) scale(195.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F2D2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavebg);
export default __webpack_public_path__ + "static/media/savebg.9d606f1d624079194af1409711ecf44e.svg";
export { ForwardRef as ReactComponent };